interface Props {
  name: string
}

const To = ({ name }: Props) => {
  return (
    <div className="text-right">
      <h4 className="font-medium text-neutral-400">To:</h4>
      <dl>
        <dt className="sr-only">company name</dt>
        <dd>{name}</dd>
      </dl>
    </div>
  )
}

export default To
